import React from 'react';
import {
  Box,
  Container,
  Grid,
  makeStyles,
  withStyles,
  Select,
  MenuItem,
  FormControl,
  FormLabel,
  InputLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  country,
} from '@material-ui/core';

import TextField from '@material-ui/core/TextField';

import Question from '../question/Question';

const NamecardValidation = ({
  daten,
  cardcontent,
  handleUpdate,
  country,
  hovercolor,
}) => {
  const useStyles = makeStyles({
    ccsLabelFocused: {
      color: hovercolor + ' !important',
    },
    formLabelFocused: {
      color: hovercolor + ' !important',
    },
    cssFocused: {
      boxShadow: 'none',
      '& .MuiInput-input': {
        border: '1px ' + hovercolor + ' solid !important',
        borderBottom: '2px ' + hovercolor + ' solid !important',
        boxShadow: 'none',
      },
    },
    underline: {
      '&::after': {
        border: '1px solid ' + hovercolor + ' !important',
      },
    },
    formControl: {
      minWidth: 100,
    },
  });
  let cardID =
    daten['chain'].length > 0
      ? daten['chain'][daten['chain'].length - 1].toString()
      : daten['chain'][0].toString();
  let step = daten['chain'].length;
  'anrede' in daten['info'][cardID]
    ? 0
    : (daten['info'][cardID]['anrede'] = -1); //Create Dict in Info if not exists
  'name' in daten['info'][cardID] ? 0 : (daten['info'][cardID]['name'] = ''); //Create Dict in Info if not exists
  const handleChange = e => {
    daten['info'][cardID]['anrede'] = e.target.value;
    if (
      daten['info'][cardID]['anrede'] != -1 &&
      daten['info'][cardID]['vorname'] != '' &&
      daten['info'][cardID]['nachname'] != '' &&
      daten['info'][cardID]['vorname']?.length >= 2 &&
      daten['info'][cardID]['nachname']?.length >= 2 &&
      daten['info'][cardID]['telefon'] != '' &&
      daten['info'][cardID]['telefon']?.length >= 7 &&
      daten['info'][cardID]['vorname'] != undefined &&
      daten['info'][cardID]['nachname'] != undefined &&
      daten['info'][cardID]['telefon'] != undefined
    ) {
      daten['info'][cardID]['weiterButtonAllow'] = 1;
    } else {
      daten['info'][cardID]['weiterButtonAllow'] = 0;
    }

    handleUpdate(daten);
  };
  const handleChangeName = (e, typ) => {
    if (typ == 'telefon') {
      const re = /^[0-9\b+() -/]+$/;
      daten['info'][cardID]['validiert'] = 1;
      daten['info'][cardID]['phoneval'] = 0;

      if (e.target.value === '' || re.test(e.target.value)) {
        daten['info'][cardID][typ] = e.target.value;
      }
    } else {
      daten['info'][cardID][typ] = e.target.value;
    }

    if (daten['info'][cardID]['countrycode'] == undefined) {
      daten['info'][cardID]['countrycode'] = country;
    }

    if (
      daten['info'][cardID]['anrede'] != -1 &&
      daten['info'][cardID]['vorname'] != '' &&
      daten['info'][cardID]['nachname'] != '' &&
      daten['info'][cardID]['vorname']?.length >= 2 &&
      daten['info'][cardID]['nachname']?.length >= 2 &&
      daten['info'][cardID]['telefon'] != '' &&
      daten['info'][cardID]['telefon']?.length >= 7 &&
      daten['info'][cardID]['vorname'] != undefined &&
      daten['info'][cardID]['nachname'] != undefined &&
      daten['info'][cardID]['telefon'] != undefined &&
      daten['info'][cardID]['validiert'] != 0
    ) {
      daten['info'][cardID]['weiterButtonAllow'] = 1;
    } else {
      daten['info'][cardID]['weiterButtonAllow'] = 0;
    }

    handleUpdate(daten);
  };

  const classes = useStyles();
  let options;

  if (country == 'de') {
    options = (
      <>
        {' '}
        <option value="de" selected>
          Deutschland
        </option>
        <option value="at">Österreich</option>
        <option value="ch">Schweiz</option>
      </>
    );
  }
  if (country == 'at') {
    options = (
      <>
        {' '}
        <option value="de">Deutschland</option>
        <option value="at" selected>
          Österreich
        </option>
        <option value="ch">Schweiz</option>
      </>
    );
  }
  if (country == 'ch') {
    options = (
      <>
        {' '}
        <option value="de">Deutschland</option>
        <option value="at">Österreich</option>
        <option value="ch" selected>
          Schweiz
        </option>
      </>
    );
  }

  let renderObjekt = (
    <div
      className="flex flex-col justify-center w-260px md:w-400px"
      id="namecard"
    >
      <div className="flex flex-col justify-between items-center mt-10px   ">
        <FormControl component="fieldset">
          <FormLabel
            component="legend"
            className="justify-center flex"
            classes={{
              focused: classes.formLabelFocused,
            }}
          >
            Anrede
          </FormLabel>
          <RadioGroup
            row
            aria-label="anrede"
            name="row-radio-buttons-group"
            value={daten['info'][cardID]['anrede']}
            onChange={handleChange}
            color="default"
            className={
              daten['info'][cardID]['anrede'] != 'Herr' &&
              daten['info'][cardID]['anrede'] != 'Frau' &&
              daten['info'][cardID]?.showerrors == 1
                ? 'flex justify-center border-1 border-red-600 p-2'
                : 'flex justify-center '
            }
          >
            <FormControlLabel
              value={'Herr'}
              control={<Radio color="default" />}
              label="Herr"
            />
            <FormControlLabel
              value="Frau"
              control={<Radio color="default" />}
              label="Frau"
            />
          </RadioGroup>
        </FormControl>

        <div className="flex items-center">
          <div className="w-360px smx:w-420px flex flex-wrap items-center justify-center p-2">
            <div className="m-2">
              <TextField
                InputProps={{
                  style: {
                    width: '160px',
                    border:
                      (daten['info'][cardID]['vorname']?.length < 2 ||
                        daten['info'][cardID]['vorname'] == undefined) &&
                      daten['info'][cardID]?.showerrors == 1
                        ? '1px solid red'
                        : '',
                  },
                  classes: {
                    focused: classes.cssFocused,
                    underline: classes.underline,
                  },
                }}
                id="vorname"
                name="vorname"
                label="Vorname"
                value={
                  daten['info'][cardID]['vorname']
                    ? daten['info'][cardID]['vorname']
                    : ''
                }
                InputLabelProps={{
                  classes: {
                    focused: classes.ccsLabelFocused,
                  },
                }}
                onChange={e => handleChangeName(e, 'vorname')}
              ></TextField>
            </div>
            <div className="m-2">
              <TextField
                InputProps={{
                  style: {
                    width: '160px',
                    border:
                      (daten['info'][cardID]['nachname']?.length < 2 ||
                        daten['info'][cardID]['nachname'] == undefined) &&
                      daten['info'][cardID]?.showerrors == 1
                        ? '1px solid red'
                        : '',
                  },
                  classes: {
                    focused: classes.cssFocused,
                    underline: classes.underline,
                  },
                }}
                id="nachname"
                name="nachname"
                label="Nachname"
                value={
                  daten['info'][cardID]['nachname']
                    ? daten['info'][cardID]['nachname']
                    : ''
                }
                InputLabelProps={{
                  classes: {
                    focused: classes.ccsLabelFocused,
                  },
                }}
                onChange={e => handleChangeName(e, 'nachname')}
              ></TextField>
            </div>
          </div>
        </div>
        <div className="w-360px smx:w-420px flex flex-wrap items-center justify-center p-2">
          <div className="m-2">
            <select
              name="Land"
              size="1"
              onChange={e => handleChangeName(e, 'countrycode')}
              className="mr-15px w-160px "
              style={{ marginTop: '16px', height: '41x' }}
            >
              {options}
            </select>
          </div>
          <div className="m-2">
            <TextField
              InputProps={{
                style: {
                  width: '160px',
                  border:
                    (daten['info'][cardID]['telefon']?.length == 0 ||
                      daten['info'][cardID]['validiert'] == 0 ||
                      daten['info'][cardID]['telefon'] == undefined) &&
                    daten['info'][cardID]?.showerrors == 1
                      ? '1px solid red'
                      : '',
                },
                classes: {
                  focused: classes.cssFocused,
                  underline: classes.underline,
                },
              }}
              id="telefon"
              name="telefon"
              label="Telefon"
              value={
                daten['info'][cardID]['telefon']
                  ? daten['info'][cardID]['telefon']
                  : ''
              }
              InputLabelProps={{
                classes: {
                  focused: classes.ccsLabelFocused,
                },
              }}
              onChange={e => handleChangeName(e, 'telefon')}
              className="ml-15px"
            ></TextField>
          </div>
          <div
            className={
              (daten['info'][cardID]['telefon']?.length == 0 ||
                daten['info'][cardID]['validiert'] == 0 ||
                daten['info'][cardID]['telefon'] == undefined) &&
              daten['info'][cardID]?.showerrors == 1
                ? 'flex text-center text-red-600'
                : 'hidden'
            }
          >
            Falsche Telefonnummer bitte geben Sie Ihre richtige Telefonnummer
            ein.
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="h-full flex flex-col justify-between ">
      <div className="text-center mt-20px">
        <Question questionNo={step} questionText={cardcontent['headline']} />
      </div>
      <div className="mx-auto">{renderObjekt}</div>

      <div className="h-40px"></div>
    </div>
  );
};

export default NamecardValidation;
